if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
            const summary = details.querySelector('summary');
            if (summary) {
              summary.addEventListener('click', () => { this._userOpened = true; });
            }
          });
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);

        // Scroll the tab heading into view after the open/close animations settle (250ms each)
        if (this._userOpened) {
          this._userOpened = false;
          const summary = details.querySelector('summary');
          if (summary) {
            setTimeout(() => {
              const stickyEl = document.querySelector('sticky-header');
              const headerOffset = stickyEl ? stickyEl.offsetHeight : 0;
              const top = summary.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
              window.scrollTo({ top, behavior: 'smooth' });
            }, 280);
          }
        }
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}
